@if (showNavBar) {
  <div>
    <app-navbar [showHomeButton]="showHomeButton"></app-navbar>
  </div>
}
<router-outlet/>

